import RequestNewPassword from './container';

export default RequestNewPassword;
